/**
 * Fractional indexing helpers for card positions.
 *
 * The backend stores `position` as DOUBLE PRECISION. We assign new
 * positions client-side from drag-drop:
 *   - Drop above first  → max - 1.0 (or 0 if no cards)
 *   - Drop below last   → max + 1.0
 *   - Drop between A,B  → (A + B) / 2
 *
 * After ~53 successive midpoint insertions float precision degrades to
 * the point a midpoint equals one of its neighbours. We expose
 * `needsRebalance(positions)` so the caller can ask the backend to
 * renumber the column when this happens.
 */

const BIG_GAP = 1.0;
const REBALANCE_EPSILON = 1e-6;

export function positionForDrop(
  beforePos: number | undefined,
  afterPos: number | undefined,
): number {
  if (beforePos === undefined && afterPos === undefined) return BIG_GAP;
  if (beforePos === undefined && afterPos !== undefined) return afterPos - BIG_GAP;
  if (beforePos !== undefined && afterPos === undefined) return beforePos + BIG_GAP;
  // Both defined.
  const a = beforePos as number;
  const b = afterPos as number;
  return (a + b) / 2;
}

export function needsRebalance(sortedPositions: readonly number[]): boolean {
  for (let i = 1; i < sortedPositions.length; i += 1) {
    const a = sortedPositions[i - 1] as number;
    const b = sortedPositions[i] as number;
    if (b - a < REBALANCE_EPSILON) return true;
  }
  return false;
}
